/**
 * Format a number with thousand separators (e.g. 1234567 → "1,234,567").
 * - Strips currency prefixes embedded in the value (e.g. "KSh1234" → 1234).
 * - Returns "0" when the value is null/undefined/empty/NaN.
 * - Preserves up to 2 decimal places, no minimum decimals.
 */
export const formatNumber = (val) => {
  if (val === null || val === undefined || val === "") return "0";
  // If the value is a string with currency prefix (e.g. "KSh 1234.56"), strip non-numeric.
  const cleaned = typeof val === "string" ? val.replace(/[^0-9.\-]/g, "") : val;
  const num = parseFloat(cleaned);
  if (isNaN(num)) return "0";
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export default formatNumber;
